import { withTheme, withStyles } from '@material-ui/core';
import { compose } from 'recompose';
import { formatAddress } from '../../../../../Dispatch/utils/utils';
import { DROP_TYPE } from '../../../constants';
import TrailerDropHookIcon from '../../../../../Dispatch/RouteExecution/utils/DriverStatus/Icons/TrailerDropHookIcon';

const styles = (theme) => ({
  dropInfo: {
    fontWeight: 500,
    fontSize: theme.dispatchCardTextFontSize,
    paddingRight: 8
  },
  dropStatus: {
    paddingTop: 2
  },
  dropContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingTop: 4
  },
  dropIcon: {
    paddingTop: 4,
    paddingRight: 6,
    color: theme.completeStopText
  }
});
const TrailerDropStop = ({ classes, stopData, route, active, theme }) => {
  const fullAddress = formatAddress({
    address: stopData.consigneeDetails?.address,
    city: stopData.consigneeDetails?.city,
    state: stopData.consigneeDetails?.state,
    zip: stopData.consigneeDetails?.zip
  });
  return (
    <div className={classes.dropContainer}>
      <div className={classes.dropIcon}>
        <TrailerDropHookIcon color={active ? theme.white : theme.completeStopText} />
      </div>
      <div>
        <div className={classes.dropInfo}>
          <div>DROP TYPE: {DROP_TYPE[stopData.dropType]} </div>
          <div>{fullAddress}</div>
        </div>
        <div className={classes.dropInfo}>
          {route.trailerName} | Status Dropped: {stopData.actualArrivalTime}
        </div>
      </div>
    </div>
  );
};

export default compose(withStyles(styles), withTheme())(TrailerDropStop);
